module.exports = "/*!\n * jQuery UI Tooltip 1.13.3\n * https://jqueryui.com\n *\n * Copyright OpenJS Foundation and other contributors\n * Released under the MIT license.\n * https://jquery.org/license\n *\n * https://api.jqueryui.com/tooltip/#theming\n */\n.ui-tooltip {\n\tpadding: 8px;\n\tposition: absolute;\n\tz-index: 9999;\n\tmax-width: 300px;\n}\nbody .ui-tooltip {\n\tborder-width: 2px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/jquery-ui/themes/base/tooltip.css
// module id = 473
// module chunks = 0